import FormattedMessage from 'I18n/components/FormattedMessage';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { useLowLevelAuthFlowMachine } from './LowLevelAuthFlowMachineContext';
import { useFinishAuth } from './hooks/useFinishAuth';
import { jsx as _jsx } from "react/jsx-runtime";
export function LowLevelFinishAuthButton({
  disabled,
  label
}) {
  const {
    state
  } = useLowLevelAuthFlowMachine();
  const {
    authConfig
  } = state.context;
  const {
    appName
  } = authConfig;
  const {
    startAuth,
    isLoading,
    hasFailed
  } = useFinishAuth();
  return /*#__PURE__*/_jsx(LoadingButton, {
    use: "primary",
    disabled: disabled,
    loading: isLoading,
    failed: hasFailed,
    onClick: () => startAuth(),
    children: label !== null && label !== void 0 ? label : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "unifiedAuthCore.auth.connectTo",
      options: {
        appName
      }
    })
  });
}